module.exports = __webpack_public_path__ + "static/img/app-logo.9e6dca59.png";